module.exports = __webpack_public_path__ + "img/22071601.3fea55a1.jpg";